var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFd2Img1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0839844 14.0833C0.0839844 6.30532 6.38931 0 14.1673 0C21.9453 0 28.2507 6.30532 28.2507 14.0833C28.2507 21.8613 21.9453 28.1667 14.1673 28.1667C6.38931 28.1667 0.0839844 21.8613 0.0839844 14.0833Z",
    fill: "#C49A6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.553 11.156C15.4589 11.252 15.4062 11.381 15.4062 11.5154C15.4062 11.6498 15.4589 11.7789 15.553 11.8749L16.3745 12.6964C16.4705 12.7905 16.5996 12.8432 16.734 12.8432C16.8684 12.8432 16.9974 12.7905 17.0934 12.6964L19.0291 10.7607C19.2873 11.3312 19.3655 11.9669 19.2532 12.583C19.141 13.1991 18.8436 13.7663 18.4008 14.2092C17.958 14.652 17.3907 14.9493 16.7746 15.0616C16.1585 15.1738 15.5228 15.0957 14.9523 14.8375L11.4043 18.3855C11.2 18.5897 10.923 18.7045 10.6341 18.7045C10.3452 18.7045 10.0682 18.5897 9.86394 18.3855C9.65968 18.1812 9.54492 17.9041 9.54492 17.6153C9.54492 17.3264 9.65968 17.0494 9.86394 16.8451L13.4119 13.2971C13.1537 12.7266 13.0756 12.0909 13.1878 11.4748C13.3001 10.8587 13.5974 10.2914 14.0402 9.84862C14.4831 9.40579 15.0503 9.10844 15.6664 8.99619C16.2825 8.88393 16.9182 8.96211 17.4887 9.22029L15.5582 11.1509L15.553 11.156Z",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFd2Img1);
export default __webpack_public_path__ + "static/media/FD2img1.444e3586b24e66096d91b003017ae271.svg";
export { ForwardRef as ReactComponent };